// eslint-disable-next-line func-names
export default function ({ route, store, redirect }) {
  if (!store.state.auth.loggedIn) {
    return redirect(`/login/?inc=${route.path}`);
  }
  return true;
}
